'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$28() {
  this.bgA = null;
  this.bgy = null;
  this.bgz = false;
  this.bgw = null;
  this.bgx = false;
  this.bgB = false;
  this.bgC = false;
  this.bgA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$28 as $c_Lpresto_PrestoRouter$$anon$28 };
$p = $c_Lpresto_PrestoRouter$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$28;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$28() {
}
export { $h_Lpresto_PrestoRouter$$anon$28 as $h_Lpresto_PrestoRouter$$anon$28 };
$h_Lpresto_PrestoRouter$$anon$28.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bgA;
});
$p.t = (function() {
  if ((!this.bgz)) {
    this.bgy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgz = true;
  }
  return this.bgy;
});
$p.ae = (function() {
  if ((!this.bgx)) {
    this.bgw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgx = true;
  }
  return this.bgw;
});
$p.w = (function() {
  if ((!this.bgC)) {
    this.bgB = false;
    this.bgC = true;
  }
  return this.bgB;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$28, "presto.PrestoRouter$$anon$28", ({
  NT: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$28 as $d_Lpresto_PrestoRouter$$anon$28 };
//# sourceMappingURL=presto.-Presto-Router$$anon$28.js.map
